// Init productCustomise object
let productCustomise = {};
// Init function for registering event listeners
let registerCustomiseEventListeners;
// Deprecated function in merged product JS but still in use in product-add-to-bag.js
let ctaState = () => {
  // CTA button state
}


// All customisation JS wrapped in conditional to only apply to available products
if(addToBagButton) {


  const urlParams = new URLSearchParams(window.location.search);
  let urlVariantId = urlParams.get('variant') ? urlParams.get('variant') : null;
  let urlBespokeSize = urlParams.get('bespoke-size') ? urlParams.get('bespoke-size') : null;
  const customiseSections = document.querySelectorAll('.customise-section');
  const upgradesSection = document.querySelector('.product-upgrades');
  const firstOrSelectedVariantId = productTop.getAttribute('data-selected-variant-id');
  const defaultProductAvailability = productTop.getAttribute('data-product-availability') ? productTop.getAttribute('data-product-availability') : null;
  //const shippingTime = document.getElementById('shipping-time');
  const customiseInfo = productTop.querySelector('.customise-info');
  // const outOfStockMessage = productTop.querySelector('.customise-message.out-of-stock');
  let defaultShippingTime = productTop.getAttribute('data-product-shipping-time') ? productTop.getAttribute('data-product-shipping-time') : null;
  // if(outOfStockMessage && defaultProductAvailability == 'out-of-stock') {
  //   defaultShippingTime = outOfStockMessage.innerText.trim();
  // }
  const productCTA = document.getElementById('product-cta');
  let multiOptionVariants = productTop.getAttribute('data-multi-option-variants') ? true : false;
  let multiOptionVariantsSelection = {};


  // Build productCustomise object default selection
  productCustomise = {
    sections: [],
    selection: {
      variant_id: firstOrSelectedVariantId, // Init with liquid's "selected_or_first_available_variant"
      shipping_time: defaultShippingTime, // Init with out-of-stock message OR product's default shipping time
      availability_status: defaultProductAvailability, // Init with product's default availability status
      props: {},
      upgrades: []
    }
  };



  // Build productCustomise object sections
  const buildCustomiseObjectSection = (customiseSection, i) => {
    productCustomise.sections[i] = {};
    // DOM element
    productCustomise.sections[i].dom_element = customiseSection;
    // Customisation type
    productCustomise.sections[i].customisation_type = customiseSection.getAttribute('data-customise-type');
    // UI type
    productCustomise.sections[i].ui_type = '';
    if (customiseSection.querySelector('.customise-options-block .pills')) {
      productCustomise.sections[i].ui_type = 'pills';
    } else if (customiseSection.querySelector('.customise-options-block .band-option')) {
      productCustomise.sections[i].ui_type = 'band-options';
    } else if (customiseSection.querySelector('.customise-options-block .customise-dropdown-btn')) {
      productCustomise.sections[i].ui_type = 'dropdown';
    }
    // Add-on
    productCustomise.sections[i].add_on = customiseSection.classList.contains('add-on') ? true : false;
    productCustomise.sections[i].add_on_variant_id = null;
    // Multi-option variants
    productCustomise.sections[i].multi_option_variants = customiseSection.getAttribute('data-multi-option-variant-section') == 'true' ? true : false;
    // Options
    productCustomise.sections[i].options = [];
    const getOptionData = (optionElements)  => {
      optionElements.forEach(function(option, j){
        productCustomise.sections[i].options[j] = {
          variant_title: option.innerText.replace('\n', ' '),
          variant_id: option.getAttribute('data-variant-id'),
          variant_availability_status: option.getAttribute('data-availability'),
          variant_shipping_time: option.getAttribute('data-shipping-time'),
          option_dom_element: option
        };
      });
    }
    let optionElements;
    if (customiseSection.querySelector('.customise-options-block .pill')) {
      optionElements = customiseSection.querySelectorAll('.customise-options-block .pill');
    } else if (customiseSection.querySelector('.customise-options-block .band-option')) {
      optionElements = customiseSection.querySelectorAll('.customise-options-block .band-option');
    } else if (customiseSection.querySelector('.customise-options-block .dropdown-option')) {
      optionElements = customiseSection.querySelectorAll('.customise-options-block .dropdown-option');
    }
    getOptionData(optionElements);
    // Default HTML
    productCustomise.sections[i].default_innerHTML = customiseSection.innerHTML;
    // Required status
    productCustomise.sections[i].required = false;
    if (customiseSection.getAttribute('data-required') == 'true') {
      productCustomise.sections[i].required = true;
    }
    // Complete status
    productCustomise.sections[i].complete = false;
    if (customiseSection.querySelector('.customise-options-block .pill.active')) {
      productCustomise.sections[i].complete = true;
    }
    // Customise property (for cart)
    productCustomise.sections[i].customise_prop = customiseSection.getAttribute('data-customise-prop');
  }





  // Get index of closest customise section from element
  const getCustomiseSectionIndex = (el) => {
    let thisCustomiseSection = el.closest('.customise-section');
    let thisCustomiseSectionIndex = Array.from(customiseSections).indexOf(thisCustomiseSection);
    return thisCustomiseSectionIndex;
  }




  // Push variant ID of selected to URL parameter
  const changeUrlVariantId = (variantId) => {
    urlParams.set('variant', variantId);
    let updatedParams = urlParams.toString();
    window.history.replaceState({}, '', `${window.location.pathname}?${updatedParams}`);
  }




  // Get inner text excluding text of child elements
  const getDirectInnerTextOnly = (el) => {
    let cloneElement = el.cloneNode(true);
    let children = Array.from(cloneElement.children);
    if(children) {
      children.forEach((child) => {
        child.remove();
      });
    }
    return cloneElement.innerText.trim();
  }




  // Update product price upon selection of price-dependent variant
  const updateProductPrice = (selection) => {
    const productPrice = document.getElementById('product-price');
    const productCompareAtPrice = document.getElementById('product-compare-at-price');
    const priceBlock = document.getElementById('price-and-metal');
    if (productPrice.innerText !== selection.querySelector('.price').innerText) {
      productPrice.innerText = selection.querySelector('.price').innerText;
    }
    if (selection.getAttribute('data-compare-at-price')) {
      // Set compare-at-price and show it
      productCompareAtPrice.innerText = selection.getAttribute('data-compare-at-price');
      priceBlock.classList.add('has-compare-at-price');
    } else {
      // Hide compare-at-price
      priceBlock.classList.remove('has-compare-at-price');
    }
  } // updateProductPrice()




  // Apply upgrades extended shipping time
  const upgradesShippingExtension = () => {

    //  Initially reset shipping time to selected variant shipping time
    let selectedVariant = productJSON.variants.find(v => v.id == productCustomise.selection.variant_id);
    productCustomise.selection.shipping_time = selectedVariant.shipping_time;

    // If any Upgrades or Engraving are applied
    if(productCustomise.selection.upgrades.length || productCustomise.selection.props['Engraving']) {

      // Function to take a shipping time string and return number of days
      const getShippingDays = (shippingTimeString) => {
        // Shipping time defined in days
        if(shippingTimeString.toLowerCase().includes('day')) {
          let days = shippingTimeString.toLowerCase().replace('days', '').replace('day', '').trim();
          if(days.includes ('-')) {
            return parseInt(days.split('-')[1].trim());
          } else {
            return parseInt(days);
          }
        }
        // Shipping time defined in weeks
        else if(shippingTimeString.toLowerCase().includes('week')) {
          let weeks = shippingTimeString.toLowerCase().replace('weeks', '').replace('week', '').trim();
          if(weeks.includes ('-')) {
            return parseInt(weeks.split('-')[1].trim()*7);
          } else {
            return parseInt(weeks*7);
          }
        }
      }

      // Get array of all applied Upgrades and Engraving shipping times
      let allUpgradesShippingTimes = [];
      const upgradeButtons = upgradesSection.querySelectorAll('.upgrade-button');
      productCustomise.selection.upgrades.forEach((upgrade) => {
        let upgradeButton = Array.from(upgradeButtons).find(b => b.getAttribute('data-upgrade-variant-title') == upgrade.variant_title);
        let upgradeShippingTime = upgradeButton.getAttribute('data-upgrade-shipping-time');
        if(upgradeShippingTime) {
          allUpgradesShippingTimes.push(upgradeShippingTime);
        }
      });
      if(productCustomise.selection.props['Engraving']) {
        const engravingButton = document.getElementById('upgrade-engraving-button');
        let upgradeShippingTime = engravingButton.getAttribute('data-upgrade-shipping-time');
        if(upgradeShippingTime) {
          allUpgradesShippingTimes.push(upgradeShippingTime);
        }
      }

      // Compare all to initial shipping time and apply the greater as new shipping time
      allUpgradesShippingTimes.forEach((upgradeShippingTime) => {
        if(getShippingDays(upgradeShippingTime) > getShippingDays(productCustomise.selection.shipping_time)) {
          productCustomise.selection.shipping_time = upgradeShippingTime;
        }
      });

    }

  } // upgradesShippingExtension()




  // Update gallery with image src
  const updateProductGallery = (imgSrc) => {
    if(imgSrc) {
      imgSrc = imgSrc.replace(/\.(jpg|png|webp).*$/i, ""); // Use regex to get image path before file extension
      const gallery = document.getElementById('product-gallery');
      const galleryImages = gallery.querySelectorAll('.display-box img');
      const thumbnailImages = gallery.querySelectorAll('.gallery-thumbnails img');
      // Check for matching image src in gallery and thumbnails
      let galleryVariantImage = Array.from(galleryImages).find(img => img.src.includes(imgSrc));
      let thumbnailVariantImage = Array.from(thumbnailImages).find(img => img.src.includes(imgSrc));
      if(galleryVariantImage) {
        let slide = galleryVariantImage.closest('.slick-slide');
        let slideIndex = Array.from(gallery.querySelectorAll('.display-box .slick-slide')).indexOf(slide);
        // Slick Slider runs on jQuery:
        slideIndex = window.innerWidth <= desktopBreakPoint ? slideIndex-1 : slideIndex; // Account for cloned slide on mobile at index [0]
        $('#product-gallery .slider').slick('slickGoTo', slideIndex); // Corresponding thumbnail changes after slide change
      }
      if(thumbnailVariantImage) {
        gallery.querySelectorAll('.gallery-thumbnail').forEach(thumbnail => thumbnail.classList.remove('active'));
        thumbnailVariantImage.closest('.gallery-thumbnail').classList.add('active');
      }
    }
  }




  // Multi-option variant (MOV) check and apply
  const multiOptionVariantsApply = (selection) => {

    // Update MOV selection object
    let selectionOptionName = selection.getAttribute('data-variant-option-name');
    let selectionOptionValue = selection.getAttribute('data-variant-option-value');
    multiOptionVariantsSelection[selectionOptionName] = selectionOptionValue;
    // Check for any incomplete MOV sections
    let allSectionsComplete = true;
    for (let i = 0; i < productCustomise.sections.length; i++) {
      if (productCustomise.sections[i].multi_option_variants == true && productCustomise.sections[i].complete == false) {
        allSectionsComplete = false;
        break;
      }
    }
    // Apply MOV selection
    if(allSectionsComplete == true) {
      // Convert selection object to array of values
      let selectionValues = [];
      Object.values(multiOptionVariantsSelection).forEach((value) => {
        selectionValues.push(value);
      });
      // Cross check multiOptionVariantsSelection with product JSON and determine variant ID
      for (let i = 0; i < productJSON.variants.length; i++){
        let variant = productJSON.variants[i];
        // If all selectionValues are in variantOptionValues array, this is the matching variant
        // Ref: https://stackoverflow.com/questions/53606337/check-if-array-contains-all-elements-of-another-array
        if(selectionValues.every(v => variant.option_values.includes(v)) == true) {
          // Update selected variant ID and title
          productCustomise.selection.variant_id = variant.id;
          productCustomise.selection.variant_title = variant.title;
          // Update product price
          const productPrice = document.getElementById('product-price');
          const productCompareAtPrice = document.getElementById('product-compare-at-price');
          const priceBlock = document.getElementById('price-and-metal');
          productPrice.innerText = variant.price_formatted;
          if (variant.compare_at_price !== "") { // Set compare-at-price and show it
            productCompareAtPrice.innerText = variant.compare_at_price_formatted;
            priceBlock.classList.add('has-compare-at-price');
          } else { // Hide compare-at-price
            priceBlock.classList.remove('has-compare-at-price');
          }
          // Update availability and shipping
          productCustomise.selection.availability_status = variant.availability_status;
          productCustomise.selection.shipping_time = variant.shipping_time;
          upgradesShippingExtension();
          // Push variant ID of selected to URL parameter
          changeUrlVariantId(variant.id);
          if(productCustomise.selection.props['Size']) {
            let bespokeSize = productCustomise.selection.props['Size'].split(' - MADE TO ORDER')[0].trim();
            urlParams.set('bespoke-size', encodeURIComponent(bespokeSize));
          } else {
            urlParams.delete('bespoke-size');
          }
          let updatedParams = urlParams.toString();
          window.history.replaceState({}, '', `${window.location.pathname}?${updatedParams}`);
          // Update gallery (if selected variant has variant image)
          updateProductGallery(variant.image_src);
          // Break productJSON.variants loop as variant has been matched
          break;
        }
      }
    }

  } // multiOptionVariantsApply()






  // Register event listeners
  registerCustomiseEventListeners = (customiseSection) => {

    // Close dropdowns with click away
    const closeDropdownClickAway = (e) => {
      // Prevent action if dropdown modal is clicked or availability overlay is clicked
      //if (!e.target.closest('.dropdown-panel') && !e.target.closest('.customise-availability-overlay')){
      if (!e.target.closest('.dropdown-panel')){
        const customiseDropdowns = document.querySelectorAll('.customise-dropdown');
        customiseDropdowns.forEach(function(dropdown){
          dropdown.classList.remove('active');
          document.removeEventListener('click', closeDropdownClickAway, true); // Disable event listener after close
        });
        handleFixedElements('show');
      }
    }

    // Open dropdowns/overlays
    if (customiseSection.querySelector('.customise-dropdown-btn')) {
      let dropdownBtn = customiseSection.querySelector('.customise-dropdown-btn');
      dropdownBtn.addEventListener('click', e => {
        // Dropdown
        if (customiseSection.querySelector('.customise-dropdown')) {
          let dropdown = customiseSection.querySelector('.customise-dropdown');
          dropdown.classList.add('active');
          document.addEventListener('click', closeDropdownClickAway, true); // Enable event listener
        // Overlay
        } else if (customiseSection.querySelector('.customise-overlay')) {
          let overlay = customiseSection.querySelector('.customise-overlay');
          overlay.classList.add('active');
        }
        handleFixedElements('hide');
      });
    }

    // Close dropdowns with click X
    if (customiseSection.querySelector('.customise-dropdown')) {
      let dropdown = customiseSection.querySelector('.customise-dropdown');
      let dropdownCloseButton = dropdown.querySelector('.close-btn');
      dropdownCloseButton.addEventListener('click', e => {
        dropdown.classList.remove('active');
        handleFixedElements('show');
        document.removeEventListener('click', closeDropdownClickAway, true); // Disable event listener after close
      });
    }


    // Handle Dropdowns
    if (customiseSection.querySelector('.customise-dropdown-btn')) {

      const dropdownBtn = customiseSection.querySelector('.customise-dropdown-btn');
      const dropdown = customiseSection.querySelector('.customise-dropdown');
      const dropdownOptions = dropdown.querySelectorAll('.dropdown-panel .dropdown-option');
      let propKey = customiseSection.getAttribute('data-customise-prop');

      // Select item
      dropdownOptions.forEach(function(dropdownOption){
        dropdownOption.addEventListener('click', e => {
          // Close panel
          dropdown.classList.remove('active');
          handleFixedElements('show');
          // Update dropdown button
          let selectionTitle = getDirectInnerTextOnly(dropdownOption); // default
          if(customiseSection.classList.contains('customise-ring-size')) { // for ring-size
            selectionTitle = dropdownOption.innerText.replace('\n', ' / ');
          }
          // Update product price
          if(dropdownOption.querySelector('.price')) {
            updateProductPrice(dropdownOption);
          }
          dropdownBtn.innerHTML = `<span>${selectionTitle}</span>`;
          // Mark section complete
          customiseSection.classList.add('complete');
          productCustomise.sections[getCustomiseSectionIndex(dropdownOption)].complete = true;
          customiseSection.querySelector('.customise-prompt').style.display = 'none';
          // Update props
          // productCustomise.selection.props[propKey] = selectionTitle; // default
          if(dropdownOption.getAttribute('data-variant-option-name') == 'Size') { // for ring-size
            if(dropdownOption.getAttribute('data-variant-option-value').toLowerCase().includes('bespoke')) {
              productCustomise.selection.props[propKey] = `${dropdownOption.getAttribute('data-bespoke-size-value')} - MADE TO ORDER`;
            } else {
              delete productCustomise.selection.props[propKey];
            }
          }
          // Update gallery (switch to image of first variant matching selected)
          if(dropdownOption.getAttribute('data-variant-option-name') == 'Diamond') { // for Diamond dropdown
            for (let i = 0; i < productJSON.variants.length; i++){
              if(productJSON.variants[i].option_values.some(o => o == dropdownOption.getAttribute('data-variant-option-value'))) {
                updateProductGallery(productJSON.variants[i].image_src);
                break;
              }
            }
          }
          // Apply Multi-Option Variants
          multiOptionVariantsApply(dropdownOption);
        });
      });

    } // Handle dropdowns


    // Handle Band options
    if (customiseSection.classList.contains('customise-band')) {

      const bandOptions = customiseSection.querySelectorAll('.band-option');
      let propKey = customiseSection.getAttribute('data-customise-prop');

      // Select item
      bandOptions.forEach(function(bandOption){
        bandOption.addEventListener('click', e => {
          // Update buttons
          bandOptions.forEach((b) => {
            b.classList.remove('active');
            b.querySelector('.status').innerText = 'Switch';
          });
          bandOption.classList.add('active');
          bandOption.querySelector('.status').innerText = 'Selected';
          // Mark section complete
          customiseSection.classList.add('complete');
          productCustomise.sections[getCustomiseSectionIndex(bandOption)].complete = true;
          customiseSection.querySelector('.customise-prompt').style.display = 'none';
          // Update gallery (switch to image of first variant matching selected)
          for (let i = 0; i < productJSON.variants.length; i++){
            if(productJSON.variants[i].option_values.some(o => o == bandOption.getAttribute('data-variant-option-value'))) {
              updateProductGallery(productJSON.variants[i].image_src);
              break;
            }
          }
          // Apply Multi-Option Variants
          multiOptionVariantsApply(bandOption);
        });
      });
      // Apply default selection on first (active) band option
      customiseSection.querySelector('.band-option.active').click();

    } // Handle Band options

  } // registerCustomiseEventListeners()



  // Handle Upgrades
  if(upgradesSection) {
    let upgradeButtons = upgradesSection.querySelectorAll('.upgrade-button');
    let propKey = upgradesSection.getAttribute('data-upgrades-prop');

    // Function to update Upgrades prop
    const updateProps = (upgradeButton, action) => {
      let toggleWithButton = upgradesSection.querySelector(`#${upgradeButton.getAttribute('data-toggles-with-id')}`);
      let variantTitle = upgradeButton.getAttribute('data-upgrade-variant-title');
      let variantID = upgradeButton.getAttribute('data-upgrade-variant-id');
      if(action == 'add') {
        if(toggleWithButton) {
          productCustomise.selection.upgrades = productCustomise.selection.upgrades.filter(upgrade => upgrade.variant_title !== toggleWithButton.getAttribute('data-upgrade-variant-title')); // remove toggled upgrade from selected
        }
        if(variantTitle && !productCustomise.selection.upgrades.some(upgrade => upgrade.variant_title == variantTitle)) {
          productCustomise.selection.upgrades.push({ 'variant_id': variantID, 'variant_title': variantTitle });
          productCustomise.selection.props[propKey] = productCustomise.selection.upgrades.map(upgrade => upgrade.variant_title).join(', ');
        }
      }
      else if(action == 'remove') {
        // Handle engraving differently
        if (upgradeButton.getAttribute('id') === 'upgrade-engraving-button') {
          let propKey = document.getElementById('engraving-overlay').getAttribute('data-customise-prop');
          delete productCustomise.selection.props[propKey]; // remove Engraving prop entirely
        }
        // Else handle upgrades
        else {
          productCustomise.selection.upgrades = productCustomise.selection.upgrades.filter(upgrade => upgrade.variant_title !== variantTitle); // remove upgrade from selected
          if(productCustomise.selection.upgrades.length) {
            productCustomise.selection.props[propKey] = productCustomise.selection.upgrades.map(upgrade => upgrade.variant_title).join(', '); // update Upgrades prop
          } else {
            delete productCustomise.selection.props[propKey]; // remove Upgrades prop entirely if none selected
          }
        }
      }
    } // updateProps()

    upgradeButtons.forEach(function(upgradeButton){
      upgradeButton.addEventListener('click', e => {

        // Remove upgrade
        if(upgradeButton.classList.contains('active')) {
          upgradeButton.classList.remove('active');
          updateProps(upgradeButton, 'remove');
          upgradesShippingExtension(); // Apply upgrades shipping extension
        }
        // Apply upgrade
        else {
          let matchingOverlay = upgradesSection.querySelector(`#${upgradeButton.getAttribute('data-open-overlay-id')}`);
          let toggleWithButton = upgradesSection.querySelector(`#${upgradeButton.getAttribute('data-toggles-with-id')}`);
          if(matchingOverlay) {
            matchingOverlay.classList.add('active'); // Open matching overlay
            // Close with modal footer button
            if(matchingOverlay.querySelector('.modal-footer .modal-close')) {
              matchingOverlay.querySelector('.modal-footer .modal-close').addEventListener('click', e => {
                matchingOverlay.querySelector('.modal-header .close-btn').click();
              });
            }
            // Confirm action with modal footer CTA
            if(matchingOverlay.querySelector('.modal-footer .btn')) {
              matchingOverlay.querySelector('.modal-footer .btn').addEventListener('click', e => {
                // Close overlay
                matchingOverlay.classList.remove('active');
                setTimeout(() => { upgradeButton.classList.add('active'); }, 100);
                if(toggleWithButton) {
                  setTimeout(() => { toggleWithButton.classList.remove('active'); }, 100);
                }
                updateProps(upgradeButton, 'add');
                upgradesShippingExtension(); // Apply upgrades shipping extension
              }, { once: true }); // prevent bubbling on inner click event
            }
          } else {
            upgradeButton.classList.add('active');
            if(toggleWithButton) {
              toggleWithButton.classList.remove('active');
            }
            updateProps(upgradeButton, 'add');
            upgradesShippingExtension(); // Apply upgrades shipping extension
          }
        }

      });
    });

  } // if upgradesSection



  // Handle Engraving
  if (document.getElementById('engraving-overlay')) {

    const engravingButton = document.getElementById('upgrade-engraving-button');
    const engravingOverlay = document.getElementById('engraving-overlay');
    const engravingForm = document.getElementById('engraving-form');
    const engravingInput = document.getElementById('engraving-input');
    const engravingErrorMsg = engravingForm.querySelector('.error-message');
    const engravingSubmit = engravingForm.querySelector('.confirm-engraving');
    let propKey = engravingOverlay.getAttribute('data-customise-prop');

    const handleEngravingError = (valid, message) => {
      if(valid == true) {
        if(message && (message.includes('uppercase') || message.includes('lowercase'))) { // info
          engravingErrorMsg.innerText = message;
          engravingErrorMsg.style.display = 'block';
          engravingErrorMsg.classList.add('info');
        } else { // No error/info
          engravingInput.classList.remove('invalid');
          engravingErrorMsg.classList.remove('info');
          engravingErrorMsg.innerText = '';
          engravingErrorMsg.style.display = 'none';
        }
      } else { // error
        engravingErrorMsg.innerText = message;
        engravingErrorMsg.style.display = 'block';
        engravingErrorMsg.classList.remove('info');
        engravingInput.classList.add('invalid');
      }
    }

    // Check if input is valid or not valid
    const inputValidationCheck = (displayErrorMessage) => {

      // Clear error message
      handleEngravingError(true);

      const validChars = /^[a-zA-ZáéíóúÁÉÍÓÚ0-9\-\/\.,:;"'!@#$%&() ]*$/;

      // Input empty
      if (engravingInput.value.length == 0) {
        if (displayErrorMessage) {
          handleEngravingError(false, 'Please enter your engraving');
        }
      }
      // Check max chars
      else if (engravingInput.value.length > 12) {
        handleEngravingError(false, 'Max 12 characters');
      }
      // Check valid characters
      else if (!validChars.test(engravingInput.value.toLowerCase())) {
        handleEngravingError(false, `Valid characters include a-z, A-Z, 0-9, .,:;"'!@#$%&() `);
      }
      // Input valid
      else {
        handleEngravingError(true);
        return true;
      }
      return;

    } // inputValidationCheck

    // Confirm engraving
    const applyEngraving = (event) => {
      event.preventDefault();
      if(inputValidationCheck() === true) {
        engravingOverlay.classList.remove('active');
        engravingButton.classList.add('active');
        let engravingString = engravingInput.value;
        productCustomise.selection.props[propKey] = engravingString; // Update props
        upgradesShippingExtension(); // Apply upgrades shipping extension`
      }
      else {
        inputValidationCheck(true); // true = display Error Message
      }
    }

    // Paste, keyup, change event listeners for input
    engravingInput.addEventListener('paste', function(){ inputValidationCheck(); }, false);
    engravingInput.addEventListener('keyup', function(){ inputValidationCheck(); }, false);
    engravingInput.addEventListener('change', function(){ inputValidationCheck(); }, false);
    // Confirm engraving with button
    engravingSubmit.addEventListener('click', function(e){ applyEngraving(e); });
    // Confirm engraving by submitting form (e.g. "enter" key)
    engravingForm.addEventListener('submit', function(e){ applyEngraving(e); });

  } // Engraving





  // Apply URL variant
  const applyUrlVariant = (urlVariantId, urlBespokeSize) => {
    let variant = productJSON.variants.find(v => v.id == urlVariantId);
    variant.option_values.forEach((value, i) => {
      let preSelectedOption = productTop.querySelector(`[data-variant-option-value="${value}"]`);
      if(preSelectedOption) {
        if(!preSelectedOption.classList.contains('active')) { // Only if option is not already active
          preSelectedOption.click(); // Simulate selection on this option
        }
      }
    });
    // If URL has bespoke-size param, decode and look for bespoke option
    if(urlBespokeSize) {
      let urlBespokeSizeDecoded = decodeURIComponent(urlBespokeSize);
      let bespokeSizeOption = productTop.querySelector(`[data-bespoke-size-value="${urlBespokeSizeDecoded}"]`);
      if(bespokeSizeOption) {
        if(!bespokeSizeOption.classList.contains('active')) { // Only if option is not already active
          bespokeSizeOption.click(); // Simulate selection on this option
        }
      }
    }
  } // applyUrlVariant()




  // On page load
  customiseSections.forEach(function(customiseSection, i) {
    // Build productCustomise object section (from load state)
    buildCustomiseObjectSection(customiseSection, i);
    // Register event listeners for this section
    registerCustomiseEventListeners(customiseSection);
  });
  // Check for URL variant matching customise option
  if (urlVariantId) {
    applyUrlVariant(urlVariantId, urlBespokeSize);
  }



} // if addToBagButton